// removed by extract-text-webpack-plugin
module.exports = {"title":"src-styles----index-module---title---2apK8","banners":"src-styles----index-module---banners---2-u21","banner":"src-styles----index-module---banner---LraMy","nextInfo":"src-styles----index-module---nextInfo---2tfbO","tags":"src-styles----index-module---tags---3kDpr","topic":"src-styles----index-module---topic---1Usv1","sectionTitle":"src-styles----index-module---sectionTitle---28xGe","textField":"src-styles----index-module---textField---3-uKt","listBox":"src-styles----index-module---listBox---3KCSg"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.module.scss
// module id = 343
// module chunks = 35783957827783